
export const whitebrandedconfig = {
  iswhitebranded: true,
  companiesgroup_id: 0, // 0 = original gotaf website
  default_country: "FR"
};
